import React from 'react';
import i18n from '../../i18n';
import { Translation } from 'react-i18next';
import Header from '../../cmps/Header';
import { CardHello } from '../../cmps/EmployeeCards/CardHello';
import { genKey } from '../../utils/utils';
import Content from '../../cmps/Content';
import Config from '../../config.json';
import { DetailsList, DetailsListLayoutMode, SelectionMode, IColumn, DetailsRow, IDetailsListProps, DetailsHeader } from '@fluentui/react/lib/DetailsList';

class EmployeeDevice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            lng: i18n.language,
            myEquipment: []
        }
        const columns: IColumn[] = [
            {
                key: 'column1',
                name: i18n.t("description.columnName"),
                fieldName: 'Mitarbeitername',
                minWidth: 30,
                maxWidth: 100,
                isRowHeader: true,
                isResizable: true,
                className: "table-data",
                onRender: (item) => {
                    if (item.Status === "Closed") {
                        return (<div><span data-tip={item.Id} data-for={"Employee_" + item.Id}>{item.Name}</span></div>);
                    }
                },
                isPadded: true,
            },
            {
                key: 'column2',
                name: i18n.t("description.columnLaptop"),
                fieldName: '',
                minWidth: 30,
                maxWidth: 200,
                isRowHeader: true,
                isResizable: true,
                className: "table-data",
                onRender: (item) => {
                    if (item.Status === "Closed") {
                        return (<div><span data-tip={item.Id} data-for={"Employee_" + item.Id}>{item.Laptop}</span></div>);
                    }
                },
                isPadded: true,
            },
            {
                key: 'column3',
                name: i18n.t("description.columnHeadset"),
                fieldName: 'status',
                isRowHeader: true,
                minWidth: 30,
                maxWidth: 100,
                isResizable: true,
                className: "table-data",
                isPadded: true,
                onRender: (item) => {
                    if (item.Status === "Closed") {
                        return (<div><span data-tip={item.Id} data-for={"Employee_" + item.Id}>{item.Headset}</span></div>);
                    }
                }
            },
            {
                key: 'column4',
                name: i18n.t("description.columnLaptopSleeve"),
                fieldName: 'status',
                isRowHeader: true,
                minWidth: 30,
                maxWidth: 100,
                isResizable: true,
                className: "table-data",
                isPadded: true,
                onRender: (item) => {
                    if (item.Status === "Closed") {
                        return (<div><span data-tip={item.Id} data-for={"Employee_" + item.Id}>{item.LaptopSleeve}</span></div>);
                    }
                }
            },
            {
                key: 'column5',
                name: i18n.t("description.columnBag"),
                fieldName: 'status',
                isRowHeader: true,
                minWidth: 30,
                maxWidth: 100,
                isResizable: true,
                className: "table-data",
                isPadded: true,
                onRender: (item) => {
                    if (item.Status === "Closed") {
                        return (<div><span data-tip={item.Id} data-for={"Employee_" + item.Id}>{item.Tasche}</span></div>);
                    }
                }
            },
            {
                key: 'column6',
                name: i18n.t("description.columnKeyboard"),
                fieldName: 'status',
                isRowHeader: true,
                minWidth: 30,
                maxWidth: 100,
                isResizable: true,
                className: "table-data",
                isPadded: true,
                onRender: (item) => {
                    if (item.Status === "Closed") {
                        return (<div><span data-tip={item.Id} data-for={"Employee_" + item.Id}>{item.Keyboard}</span></div>);
                    }
                }
            },
            {
                key: 'column7',
                name: i18n.t("description.columnMobilePhone"),
                fieldName: 'status',
                isRowHeader: true,
                minWidth: 30,
                maxWidth: 100,
                isResizable: true,
                className: "table-data",
                isPadded: true,
                onRender: (item) => {
                    if (item.Status === "Closed") {
                        return (<div><span data-tip={item.Id} data-for={"Employee_" + item.Id}>{item.MobilePhone}</span></div>);
                    }
                }
            },
        ];

        this.state = {
            columns: columns,
            token: this.props.match.params.token
        };   
    }
    componentDidMount() {
        this.getEmployee();
    }

    getEmployee() {
        fetch(Config.REACT_APP_BACKEND_URL + "/myequipment")
            .then(res => res.json())
            .then(result => {
                this.setState({
                    isLoaded: true,
                    myEquipment: result,
                }, () => 
                    console.log('myEquipment', this.state.myEquipment)
                );
            },
                error => {
                    this.setState({
                        isLoaded: true
                    });
                }
            )
    }


    _stylingOnRenderRow(props): IDetailsListProps['onRenderRow'] {
        if (props) {
            return <DetailsRow {...props} styles={gridStyles} />;
        }
        return null;
    }
    _onRenderDetailsHeader(props): IDetailsListProps['onRenderDetailsHeader'] {
        if (props) {
            return <DetailsHeader {...props} styles={gridHeaderStyles} />;
        }
        return null;
    }
    render() {
        const { columns } = this.state;
        
        const isMobile = document.documentElement.clientWidth < 800 ? true : false;
        const headerContent = (
            <div>
                {
                    isMobile ?
                        <div>
                            <h2 style={{ fontFamily: 'AvertaPE-Extrabold' }}><Translation>{t => t("description.myDevice").toUpperCase()}</Translation></h2>
                        </div>
                        :
                        <div>
                            <h1 style={{ fontFamily: 'AvertaPE-Extrabold' }}><Translation>{t => t("description.myDevice").toUpperCase()}</Translation></h1>
                        </div>
                }
            </div>
        );

        const currentEquipment = (
            <div>
                {this.state.myEquipment &&
                    <DetailsList
                        items={this.state.myEquipment ? this.state.myEquipment : []}
                        columns={columns}
                        selectionMode={SelectionMode.none}
                        getKey={this._getKey}
                        setKey="none"
                        onRenderRow={this._stylingOnRenderRow}
                        onRenderDetailsHeader={this._onRenderDetailsHeader}
                        layoutMode={DetailsListLayoutMode.justified}
                        isHeaderVisible={true}
                
                    />
                }
            </div>
        );

        /*const content = [
            <CardHello heading="description.myDeviceWelcomeText" description={["description.employeeWelcomeText6", "description.employeeWelcomeText2"]} key={genKey("cardhello")} />,
        ];*/

        return (
            <>
                <Header headerContent={headerContent} />
                {/*<Content content={content} lng={this.state.lng} />*/}
                <Content content={currentEquipment} lng={this.state.lng} />
            </>
        )
    }

}

const gridStyles = {
    root: {
        background: 'transparent',
    },
};
const gridHeaderStyles = {
    root: {
        backgroundColor: '#f5f5f5',
        paddingTop: '0',
        marginTop: '15px',
    },
};

export default EmployeeDevice;